import React from 'react'
import {
    IonPage,
    IonContent,
	IonButton,
	IonIcon,
} from '@ionic/react'
import { optionsOutline } from 'ionicons/icons'
import Header from './Header'
import FadeText from './FadeText'
import Roster from './Roster'
import Icon from './Icon'
import {
    useMyGame,
	useEditModeState,
	useMyTeam,
	useSection,
	useSettings,
} from './data'
import { formatDate, labelRound } from './util'
import { defaultPreset, presets } from './definitions'
import { getGameSharePreviewUrl } from './previewShareUrl'
import './game.css'

const Game = () => {
	const game = useMyGame()
	const team = useMyTeam()
	const section = useSection()
	const shareUrl = game ? getGameSharePreviewUrl({
		kind: 'roster',
		gameId: game.id,
		section,
	}) : undefined
	const matchName = [ team?.name, game?.opponent ].filter(Boolean).join(' vs ')

	return (
        <IonPage>
            <IonContent>
                <GameHeader />
                <Roster />
            </IonContent>
            <Header
				showShareButton={true}
				shareUrl={shareUrl}
				shareTitle={matchName ? `${matchName} roster` : 'AutoRoster game roster'}
			/>
        </IonPage>
	)
}

const GameHeader = () => (
    <header className="header">
        <div className="header-title">
            <Icon />
            <div className="header-title-content">
                <OpponentText />
                <UserData />
            </div>
			<SettingsButton />
        </div>
    </header>
)

const SettingsButton = () => {
	const [ editMode ] = useEditModeState()
	const settings = useSettings()

	if (!editMode)
		return null

	const presetId = (settings.preset || defaultPreset) as keyof typeof presets
	const presetName = presets[presetId]?.name || 'Custom'
	const presetLabel = presetName === 'Development' ? 'Dev' : presetName

	return (
		<div className="header-title-actions">
			<IonButton
				className="header-settings-button button-react-icon"
				color="light"
				routerLink="/settings"
				aria-label={`Settings preset ${presetName}`}
				title="Roster settings"
			>
				<IonIcon icon={optionsOutline} />
				<span className="roster-button-text">
					{presetLabel}
				</span>
			</IonButton>
		</div>
	)
}

const OpponentText = () => {

    const game = useMyGame()

    if (!game?.opponent)
        return null

    const { opponent } = game

    const htLength = opponent.length || 0
    const htClass = (
        htLength > 24 ? 'gigantic' :
        htLength > 20 ? 'huge' :
        htLength > 15 ? 'large' :
        htLength > 10 ? 'medium' :
        htLength > 6 ? 'small' : 'tiny'
    )

    return (
        <FadeText
            contentKey={opponent}
            className="header-title-block"
        >
            vs
            <div className={`header-title-opponent textlength-${htClass}`}>
                {opponent}
            </div>
        </FadeText>
    )
}

const UserData = () => {

	const game = useMyGame()

    if (!game)
        return null

    const gameRound = (game.round !== undefined && game.round !== null) && (
        <div className="header-game-name">
            {labelRound(game.round)}
        </div>
    )

   const gameVenue = game.venue && (
        <div className="header-game-venue">
            {game.venue}
        </div>
    )

    const gameTime = game.date && (
        <div className="header-game-date">
            {
                formatDate(game.date, 'long')
            }
        </div>
    )

    return (
        <FadeText className="header-userdata">
            {gameRound}
            {gameTime}
            {gameVenue}
        </FadeText>
    )
}

export default Game
